import { paginationActions, requestActions } from "./utils";

export const CONTENT_LIBRARY = requestActions("ContentLibrary/List/Get");
export const CONTENT_LIBRARY_ITEM = requestActions("ContentLibrary/Item/Get");

export const PAGINATION = {
  ...paginationActions("ContentLibrary/List/Paginate"),
  LANGUAGE: "ContentLibrary/List/Paginate/Language",
};
